import { MenuItem, Select, Typography } from '@mui/material';
import { Box } from '@mui/system';
import SheetAPI from 'api/SheetAPI';
import _ from 'lodash';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { cacheStore } from 'store/bearStore';
import { getListSectionsOfSheet, setDataSection } from 'store/reducers/sheetSlice';
import { SheetStatus } from 'utils/StringDefinition';
import { Unit } from './ResultInRow';

const RowSelectComponent = (props) => {
    const { name, description, initValue, blockNumber, listValue, symbol, paddingLeftDes, unit } = props;
    const sheetInfo = useSelector((state) => state.sheet.sheetActive);
    const user = useSelector((state) => state.user.current);
    const cacheData = cacheStore((state) => state.cacheData);
    const setCacheData = cacheStore((state) => state.setCacheData);
    const sectionData = useSelector((state) => state.sheet.dataSection);
    var index = useSelector((state) => state.calculatationSection.index);

    const dispatch = useDispatch();

    const [valueSelectBox, setValueSelectBox] = useState(initValue || listValue[0].value);
    const isEditor = user?.id === sheetInfo?.editor?.id ? true : false;
    const canEdited = (sheetInfo?.status === SheetStatus.EDITING || sheetInfo?.status === SheetStatus.CHECKED) && isEditor ? false : true;
    const sheetId = sectionData?.data?.sheetId;
    const blockData = sectionData?.data?.tool002version100?.[blockNumber];

    useEffect(() => {
        setValueSelectBox(initValue);
    }, [initValue]);

    const updateData = async (sectionDataChanged) => {
        const response = await SheetAPI.putDataSection(sectionDataChanged);
        if (response.status === 200) {
            const dataResult = response.data;

            dispatch(setDataSection(dataResult));
            dispatch(getListSectionsOfSheet(sheetId));
        }
    };

    function getTypeByName(name) {
        // Check if the name exists in the JSON object
        if (blockData.hasOwnProperty(name)) {
            // Extract the "type" based on the given "name"
            return blockData[name].type;
        } else {
            // Return an error message or handle the case when the name is not found
            return 'Name not found in the JSON object';
        }
    }

    const handleChange = (event) => {
        let newValue = event.target.value;
        setValueSelectBox(newValue);

        if (newValue !== initValue) {
            let cacheDataChanged = {
                ...cacheData,
                [name]: { value: newValue.toString(), type: getTypeByName(name) },
            };

            setCacheData(cacheDataChanged);

            let sectionDataChanged = {
                ...sectionData.data,
                tool002version100: { ...sectionData.data?.tool002version100, [blockNumber]: cacheDataChanged },
            };

            if (!_.isEqual(blockData, cacheDataChanged)) {
                // console.log(blockData, dataChanged);
                updateData(sectionDataChanged);
            }
        }
    };

    return (
        <Box component="div" sx={{ width: '100%', display: 'flex', alignItems: 'center', marginBottom: '4px !important', marginTop: '0px !important' }}>
            <Box component="div" sx={{ display: 'inline-block', width: '33%', alignItems: 'center', marginLeft: 10, paddingLeft: paddingLeftDes ? paddingLeftDes : 0 }}>
                <Typography>{description}</Typography>
            </Box>

            <Box component="div" sx={{ display: 'flex', width: '7%' }}>
                <Typography sx={{ width: symbol?.mathSymbol ? '70%' : '100%', justifyContent: 'flex-end', paddingRight: 1.5 }}>
                    {symbol?.normalText}
                    {symbol?.subText && <sub>{symbol?.subText}</sub>}
                    {symbol?.supText && <sup>{symbol?.supText}</sup>}
                </Typography>

                {symbol?.mathSymbol && <Typography sx={{ width: '30%' }}>{` ${symbol?.mathSymbol}`}</Typography>}
            </Box>

            <Box component="div" sx={{ display: 'inline-block', width: '15%' }}>
                <Select
                    defaultValue={initValue || listValue[0].value}
                    disabled={canEdited}
                    value={valueSelectBox ?? listValue[0].value}
                    onChange={handleChange}
                    sx={{
                        width: '100%',
                        textAlign: 'right',
                        height: '32px',
                        padding: 0,
                        '& .MuiInputBase-input.Mui-disabled': {
                            WebkitTextFillColor: '#272343',
                            cursor: 'not-allowed',
                        },
                    }}
                >
                    {listValue.map((item) => {
                        return (
                            <MenuItem key={item.id} value={item.value}>
                                {item?.textValue ?? item?.value}
                            </MenuItem>
                        );
                    })}
                </Select>
            </Box>

            <Box component="div" sx={{ display: 'inline-block', paddingLeft: 3 }}>
                <Unit unit={unit} />
            </Box>
        </Box>
    );
};
export default RowSelectComponent;
